import { render } from "./PartnerDelete.vue?vue&type=template&id=8a9a6a1a"
import script from "./PartnerDelete.vue?vue&type=script&lang=js"
export * from "./PartnerDelete.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__